import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceService } from '../../service.service';
import { GlobalConstants } from '../../global-config';
import { Meta,Title, DomSanitizer } from '@angular/platform-browser';
import { MetaServiceService } from '../../meta-service.service';

declare var $: any;

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss'],
})
export class BlogComponent implements OnInit {
  
  public server = GlobalConstants.apiURL;
  blogData: any;
  p: number = 1;
  // SEO Page Title Description
    public setTitle( newTitle: string) {
      this.title.setTitle( newTitle );
    }
  // SEO Page Title Description
  constructor(
    private meta: Meta,
    private title: Title,
    public service: ServiceService,
    private router: Router,
    private metaService: MetaServiceService
  ) {
      //  SEO Meta Description
        this.meta.addTags([
          { name: 'description', content: 'CViewSurvey Blogs focus on keeping you updated with the latest survey trends, feedback tips and data analyzing strategies. Refer our blogs to gain knowledge about survey software.' },
          { name: 'author', content: 'CViewSurvey' },
          { name: 'keywords', content: 'Survey Blogs, Survey Software, Survey' }
        ]);

          this.setTitle('CViewSurvey Blogs | Survey Software Solutions | Write-Ups'); 
      // End SEO Meta Description
  }

  ngOnInit(): void {
    this.getBlogAll(); 
    this.getCurrentIp(); 
    // for create canonical link 
    this.metaService.createCanonicalURL();  
  }


  currentIP:any; 
  getCurrentIp() {
    this.service.getCurrentIPAddress().subscribe((data: any) => {
      console.log(data.ip,':::::::::IP DATA::::::::::::');
      this.currentIP = data.ip;
      window.localStorage.setItem('currentIP',this.currentIP);
     // window.localStorage.setItem('BlogId','0')
    });
    (error) => {
      console.log('no data found');
    };
  }
  //===========================================================


  getBlogAll() {
    this.service.getBlog().subscribe((data: any[]) => {
      this.blogData = data;
     // console.log(this.blogData);
    });
    (error) => {
      console.log('no data found');
    };
  }

  blogNavigate(id,title,view_count) {
    let ip = window.localStorage.getItem('currentIP');
    let blogId = Number(window.localStorage.getItem('BlogId'));
    
      if(id != blogId ){// && ip != this.currentIP.toString()
        this.service.updateBlogById(id,view_count).subscribe((data: any[]) => {
        });
        window.localStorage.removeItem('BlogId')
        window.localStorage.setItem('BlogId',id)
      }
      
    let updatedTitle = title.split(" ").join("")
    this.router.navigate(['./blog-details/' + id + '/' + updatedTitle]);
  }
  
}

